import { render, staticRenderFns } from "./BasketItemsList.vue?vue&type=template&id=e2fe8106&scoped=true&"
import script from "./BasketItemsList.vue?vue&type=script&lang=js&"
export * from "./BasketItemsList.vue?vue&type=script&lang=js&"
import style0 from "./BasketItemsList.vue?vue&type=style&index=0&id=e2fe8106&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2fe8106",
  null
  
)

export default component.exports